module.exports = {
      id: "ic-templates-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-templates-usage",
      toString: function () {
        return this.url;
      }
    }